export default {
    addToAppleWallet: {
        dataTrackId: 'add-to-apple-wallet-button',
        dataTrackLinkname: 'Legg til i Apple Lommebok',
    },
    addToAppleWalletModal: {
        dataTrackId: 'add-to-apple-wallet-modal-button',
        dataTrackLinkname: 'Legg til i Apple Lommebok',
    },
    appleWalletModalNotNow: {
        dataTrackId: 'apple-wallet-modal-not-now',
        dataTrackLinkname: 'Ikke nå',
    },
    appleWalletWasItYou: {
        dataTrackId: 'apple-wallet-was-it-you',
        dataTrackLinkname: 'Var det deg?',
    },
    addToAppleWalletFailedRetry: {
        dataTrackId: 'add-to-apple-wallet-failed-retry-button',
        dataTrackLinkname: 'Prøv igjen',
    },
    applePayActivateIphone: {
        dataTrackId: 'apple-pay-activate-card-iphone',
        dataTrackLinkname: 'Fullfør verifisering på Iphone',
    },
    applePayActivateWatch: {
        dataTrackId: 'apple-pay-activate-card-watch',
        dataTrackLinkname: 'Fullfør verifisering på Watch',
    },
    applePayActivateIpad: {
        dataTrackId: 'apple-pay-activate-card-ipad',
        dataTrackLinkname: 'Fullfør verifisering på Ipad',
    },
    applePayActivationModalGoOn: {
        dataTrackId: 'apple-pay-activate-card-modal-goon',
        dataTrackLinkname: 'Gå videre',
    },
    applePayActivationModalCancel: {
        dataTrackId: 'apple-pay-activate-card-modal-cancel',
        dataTrackLinkname: 'Avbryt',
    },
};
